//@ts-check

const releaseInfo = {
    gitCommit: "281abb67",
    version: "1.0.0"
}

export default releaseInfo
